import { Suspense, useEffect } from "react";
import AppRoutes from "./view/components/routes/AppRoutes";
import Loader from "./view/components/shared/Loader";
import { getEnvVariable } from "./constants/brandConfig";
import { BRAND_NAME, META_TITLE, META_DESCRIPTION, domain } from "./constants/Branding";
import { initBrandTracking } from "./constants/Tracking";
import { errorHandler, store } from "./App.utils";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { AuthClient } from "@hypexone/uicore";
import { getBaseUrl } from "./api/api-services/environment-url/environment-url";

const SVLS_API = getBaseUrl(
  import.meta.env.VITE_NODE_ENV,
  "REACT_APP_REST_API_V2_URL"
);

export const authClient = new AuthClient(
  SVLS_API,
  sessionStorage.getItem("jwt_token"),
  errorHandler
);

function App() {
    const loadTheme = () => {
    const cssFolderName = getEnvVariable(domain, 'FOLDER_NAME') || 'default.css';
    const cssFilePath = `/theme/${cssFolderName}/variables.css`;

    // Check if an existing theme file is already loaded
    let existingLink = document.getElementById('site-theme');

    if (existingLink) {
      // Replace existing theme
      existingLink.setAttribute('href', cssFilePath);
    } else {
      // Create new theme link
      const link = document.createElement('link');
      link.id = 'site-theme';
      link.rel = 'stylesheet';
      link.href = cssFilePath;
      document.head.appendChild(link);
    }

    console.log(`Loaded theme: ${cssFolderName}`);
  };

  const updateFavicon = () => {
    let link: any = document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.setAttribute('href', getEnvVariable(domain, 'favicon'));
  };

  const updateTitle = () => {
    document.title = META_TITLE || BRAND_NAME;
  };

  const updateMetaDescription = () => {
    if (!META_DESCRIPTION) return;

    let meta: any = document.querySelector("meta[name='description']");

    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }

    meta.setAttribute("content", META_DESCRIPTION);
  };

    useEffect(() => {
    // TODO: this should only be called once.
    // getDomainConfig();
    // Load theme file
    loadTheme();
    // Load favicon
    updateFavicon();
    // Update title
    updateTitle();
    // Set this brand's meta description, if configured
    updateMetaDescription();
    // Init this brand's Facebook Pixel / GTM / gtag, if configured
    initBrandTracking();

    const params = new URLSearchParams(window.location.search);
    const url = params.get("logoUrl");
    if (url) {
      const cleanUrl = decodeURIComponent(url).trim().replace(/^"|"$/g, "");
      sessionStorage.setItem("brandLogo", cleanUrl);
    }
  }, []);
  return (
    <div className="h-full">
      <Provider store={store}>
        <Suspense fallback={<Loader />}>
          <AppRoutes />
        </Suspense>
        <ToastContainer />
      </Provider>
    </div>
  );
}

export default App;
